module.exports = __webpack_public_path__ + "static/media/error-message.99ca0f15.png";